const consoleIgnoreList = [
  // greeting message
  /Digging.into.our.code?/,

  // missing sourcemaps on certain 3rd party libraries
  /devtools.*sourcemap/,

  // same site cookies are not used in many services yet
  /A.cookie.associated.with.a.cross-site.resource.*was.set.without.the.*SameSite/,

  // a bug in "crazyegg" that the team that develops it is aware of
  /CE:.multiple.userscripts.installed/,

  // react devtools extension
  /react.devtools.backend.js/,

  // from redux-toolbelt add-on
  /CannotSerializeObjectNonSerializable/,

  // react deprecated methods warning
  /In.React.17.x/,

  // chrome messages
  /^\[Violation\].*.handler.took/,
  /^\[Violation\].Forced.reflow/,
];

export const remoteLoggingIgnoreList = [
  ...consoleIgnoreList,
  /^i18next:/,

  // ignore logger outputs to console. the logger should be tracked manually
  /^\$\[/,

  // ignore the print of the config in dev
  /^current.config..printed.only.on.dev./,

  // hot reload
  /^\[HMR\]/,
];

// High-frequency, already-handled error/warn logs that should never reach Sentry Logs.
// These are transport/retry/polling failures that are re-thrown and handled upstream
// (user-facing error states, retries, expired links). They accounted for the bulk of
// Sentry ingestion, so we drop them at the egress layer (see `logStructured` in sentry.js).
// Genuine outages remain visible via server-side monitoring and unhandled-error capture.
export const sentryLogIgnoreList = [
  // src/shared/services/http.js — logged on every failed request, then re-thrown.
  /request error/,
  // src/shared/services/apiService/apiServiceUtils.ts — logged on every final API failure.
  /Failed retry api request/,
  // src/tracker/hooks/useRoute.tsx — continuous polling on the tracker page.
  /Failed to fetch tracking route/,
  /\[usePollingTrackingData\]: Invalid trackerToken or intervalMs/,
  // src/shared/services/geocoder.ts — handled geolocation permission-API failure
  // (falls back to "permitted"). Not actionable; ~128K/14d.
  /window\.navigator\.permissions failed/,
];

export default consoleIgnoreList;
